import React from "react";
import { compose, withAppContext, withState, withActions } from "containers/HOC";
import { Form, Field } from "react-final-form";
import * as validations from "common/validations";
import Loader from "components/Loader";
import Modal from "components/new/Modal";
import ModalBody from "components/new/ModalBody";
import ModalFooter from "components/new/ModalFooter";
import Grid from "components/Grid";
import GridCell from "components/GridCell";
import SelectPack from "components/SelectPack2";
import { fetchBudget, updateBudget } from "containers/Budget/_actions";
import { getDatasets } from "./_actions";

class AddToDatasetsModal extends React.Component {
    componentDidMount() {
        this.props.fetchBudget(this.props.viewModel.analysis.farmId, this.props.viewModel.analysis.id);
        this.props.getDatasets();
    }

    _validate = (formValues) => {
        const errors = {};

        errors.datasetId = validations.required(formValues.datasetId);

        return errors;
    };

    _save = (values) => {
        if (values.datasetId === "remove") {
            values.datasetId = undefined;
            values.datasetName = undefined;
        } else {
            values.datasetName = this.props.datasets.find((d) => d.id === values.datasetId).name;
        }

        this.props.updateBudget(values, false, true, false);
    };

    render() {
        const { analysis, datasets, online } = this.props;

        if (!analysis || !datasets) return <Loader message="Loading..." />;

        let datasetOptions = datasets.map((d) => {
            return { value: d.id, text: d.name };
        });
        datasetOptions.unshift({ value: "remove", text: "No dataset" });

        return (
            <Form validate={this._validate} initialValues={analysis} onSubmit={this._save}>
                {({ values, handleSubmit, submitSucceeded }) => {
                    return (
                        <Modal title="Update dataset for analysis" allowOffline={false} skinny={true}>
                            {({ closeModal }) => (
                                <form onSubmit={handleSubmit}>
                                    <ModalBody>
                                        <Grid>
                                            <GridCell>
                                                <Field name="datasetId" label="Dataset" placeholder="Select a dataset" options={datasetOptions} requiredLabel={true} component={SelectPack} />
                                            </GridCell>
                                        </Grid>
                                    </ModalBody>
                                    <ModalFooter>
                                        <div className="ButtonBar">
                                            <div className="ButtonBar-left">
                                                <button id="cancel-button" type="button" className="Button Button--secondary" onClick={closeModal}>
                                                    Cancel
                                                </button>
                                            </div>
                                            <div className="ButtonBar-right">
                                                <button id="save-button" type="submit" className="Button" disabled={!online || submitSucceeded}>
                                                    Save
                                                </button>
                                            </div>
                                        </div>
                                    </ModalFooter>
                                </form>
                            )}
                        </Modal>
                    );
                }}
            </Form>
        );
    }
}
export default compose(
    withAppContext,
    withState((state, ownProps) => {
        const {
            viewModel: { analysis },
        } = ownProps;
        const datasets = state.dataset.datasets || [];

        const offlineFarm = state.offlineFarms.find((f) => f.id === analysis.farmId);
        const farm = offlineFarm ? offlineFarm.farm : null;
        const offlineBudget = farm ? (farm.offlineBudgets || []).find((ob) => ob.id === analysis.id && ob.isDownloaded) : null;
        const budget = offlineBudget ? offlineBudget.budget : null;

        return {
            analysis: budget,
            datasets: datasets,
        };
    }),
    withActions({ getDatasets, fetchBudget, updateBudget })
)(AddToDatasetsModal);
